// path: store/getters.js
export const tenant = state => state.tenant // 选择门店之后的 门店信息
export const navindex = state => state.navindex // 全局一级菜单
export const isActive_second = state => state.isActive_second // 全局二级菜单
export const goodsTypeOptions = state => state.goodsTypeOptions // 项目类别数据
export const productTypeOptions = state => state.productTypeOptions // 商品类别数据
export const memberLevelOptions = state => state.memberLevelOptions // 会员等级分类
export const memberSourceOptions = state => state.memberSourceOptions // 会员来源分类

export const listDatas = state => state.listDatas //
export const permissionlist = state => state.permissionlist //
export const childIndex = state => state.childIndex

export const clearListDatas = state => state.listDatas
export const searchHistoryList = state => state.searchHistoryList



// WEBPACK FOOTER //
// ./src/store/getters.js